import React, { Fragment, useState, useEffect } from 'react';
import SingleSelect from '../../common/Forms/SingleSelect';

const CampaignSelection = ({ initialCampaign, campaignOptions }) => {
  const initialScope = initialCampaign ? 'Campaign' : 'Product';
  const [scope, setScope] = useState(initialScope)
  const [campaign, setCampaign] = useState(initialCampaign);

  useEffect(() => {
    if (scope === 'Campaign') {
      $('#campaign-data').show();
    } else {
      $('#campaign-data').hide();
    }
  }, [scope]);

  const handleChange = (option) => {
    setScope(option.value);
  };

  const handleCampaign = (option) => {
    setCampaign(option);
  };

  return (
    <Fragment>
      <div style={ { width: '100%' } }>
        <SingleSelect
          handleChange={handleChange}
          options={[{ label: 'Campaign', value: 'Campaign' }, { label: 'Product', value: 'Product' }]}
          selectedValue={{ label: scope, value: scope }}
          placeholderText="Select Affect of Trigger"
        />
      </div>

      <br />

      {scope === 'Campaign' && (
        <div style={ { width: '100%' } }>
          {/*
            Submit '' rather than whatever `campaign` happens to be. `campaign &&
            campaign.value` returns the falsy value ITSELF when campaign is not an
            object -- so a boolean false prop rendered value="false", and the
            string "false" was stored as the audience on four scheduled jobs.
            The ERB no longer passes a boolean, and ScheduledJob now rejects an
            unknown audience; this keeps the input honest regardless of the prop.
          */}
          <input name="scheduled_job[campaign]"
                 value={(campaign && campaign.value) || ''}
                 hidden />
          <SingleSelect
            handleChange={handleCampaign}
            options={campaignOptions}
            selectedValue={campaign}
            placeholderText="Select Campaign"
          />
        </div>
      )}
    </Fragment>
  )
}

export default CampaignSelection;
